/**
 * Created by matthew on 5/8/19.
 */
(function($){
	
	$.fn.login = function(){
		
		var elem = $(this),
			trigger = elem.find('input[type="submit"]');
		
		trigger.on('click', function(event){
			
			$('.error-notification').hide();
			
			trigger.val('Please Wait...');
			
			event.preventDefault();
						
			var username = elem.find($('input[name="username"]')).val(),
			    password = elem.find($('input[name="password"]')).val();
						
			$.ajax({
				url: ajax_variables.ajax_url,
				type: 'POST',
				dataType: 'json',
				data: {
					'action': 'log_user_in',
					'username': username,
					'password': password,
					'remember': true
				},
				success: function(data){
										
					if(data == true){
						
						window.location.replace(window.location.href);
						
					}
					
					if(data != null){
						
						trigger.val('Login');
						$('.error-notification').html(data).show();
						
					}
					
				}
			});
		});
		
		
	}
	
	
})(jQuery);